<template>
  <el-dialog
    class="defaultDialog MultipleAccountsDialog"
    title="提示"
    :visible="true"
    width="520px"
    append-to-body
    @close="handleClose"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="constant">
      <p>
        找到多个绑定 <span class="red">{{ phone }}</span> 手机号的账号
      </p>
      <p>请选择要登录的账号</p>
      <ul>
        <li v-for="item in MultipleAccountList" :key="item.userId">
          <p class="userName"><span>用户名</span>{{ item.userName }}</p>
          <p><span>状态</span>{{ getType(item.userType) }}</p>

          <p @click="goLogin(item)" class="red">去登录 <i class="iconfont icon-arrowright"></i></p>
        </li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "MultipleAccountsDialog",
  props: {
    phone: {
      type: String,
      default: "",
      required: true,
    },
    MultipleAccountList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClose() {
      this.$emit("close");
    },
    getType(val) {
      switch (val) {
        case 1:
          return "付费会员-主账号 ";
        case 2:
          return "付费会员-子账号";
        case 3:
          return "免费会员";
      }
    },
    goLogin(item) {
      this.$emit("goLogin", item);
    },
  },
};
</script>
<style lang="scss">
.MultipleAccountsDialog {
  .el-dialog__body {
    padding-bottom: 8px;
    padding-right: 8px;
  }
}
</style>

<style scoped lang="scss">
@import "../../../assets/config";

.MultipleAccountsDialog {
  .constant {
    color: #333333;
    line-height: 22px;
    .red {
      color: $theme-color;
    }
    p {
      padding-bottom: 8px;
    }
    ul {
      font-size: 12px;
      padding-top: 8px;
      padding-right: 37px;
      max-height: 250px;
      overflow-y: auto;
      li {
        margin-bottom: 16px;
        background: #fafafa;
        border: 1px solid #dddddd;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        line-height: 18px;
        padding: 12px 4px 12px 12px;
        p {
          padding: 0;
          text-align: left;
          width: 145px;
          &.userName {
            width: 155px;
            margin-right: 5px;
          }

          span {
            padding-right: 10px;
            color: #666666;
          }
          i {
            font-size: 12px;
            transform: scale(0.7) translateX(-5px);
            display: inline-block;
          }
          &.red {
            cursor: pointer;
            text-align: right;
            width: 77px;
          }
        }
      }
    }
  }
}
</style>
